import { useTranslation } from "react-i18next";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/stores/theme";

export function TopBar() {
  const { t } = useTranslation();
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  // Селектор языка убран (единственный язык - русский). Остаётся
  // только переключатель темы.
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={toggle}
        aria-label={isDark ? t("topbar.theme.light") : t("topbar.theme.dark")}
        className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-line-soft bg-surface text-ink-mute hover:bg-surface-2 hover:text-ink transition"
      >
        {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </button>
    </div>
  );
}
